import { render } from "./VehicleItemMobile.vue?vue&type=template&id=485b79c5&scoped=true"
import script from "./VehicleItemMobile.vue?vue&type=script&lang=js"
export * from "./VehicleItemMobile.vue?vue&type=script&lang=js"

import "./VehicleItemMobile.vue?vue&type=style&index=0&id=485b79c5&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-485b79c5"]])

export default __exports__